
import Vue from "vue"
import Component from "vue-class-component"
import {Prop} from "vue-property-decorator"
import {News} from "@/news/News"

@Component
export default class NewsWidget extends Vue {
  @Prop()
  news: News
}
